import Food from './Food';
import 'bulma/css/bulma.css';

export default function App() {
  return (
    <Food />
  )
}